export const showAllRows = (setViewAllClicked, length, paginationModel, setPaginationModel) => {
  setViewAllClicked(true);
  // setPage(0);
  if (length > 100) {
    setPaginationModel({
      ...paginationModel,
      pageSize: Math.ceil(length / 25) * 25
    });
  }
  else if (length > 50) {
    setPaginationModel({
      ...paginationModel,
      pageSize: 25
    })
  }
  else if (length > 25) {
    setPaginationModel({
      ...paginationModel,
      pageSize: 50
    })
  }
  else {
    setPaginationModel({
      ...paginationModel,
      pageSize: 25
    })
  }
}

export const getNumDigits = (number: Number) => {
  return number.toString().length;
}

export const initializeState = (paginationModel, setPaginationModel, setRowsPerPageOptions, viewAllClicked, length) => {
  if (length === 0) {
    setRowsPerPageOptions([25, 50, 100]);
    setPaginationModel({
      ...paginationModel,
      pageSize: 25
    });
  }
  else if (length > 100) {
    const allRows = Math.ceil(length / 25) * 25;
    setRowsPerPageOptions([25, 50, 100, allRows]);
    if (viewAllClicked) {
      setPaginationModel({
        ...paginationModel,
        pageSize: allRows
      });
    }
  }
  else {
    setRowsPerPageOptions([25, 50, 100]);
    if (viewAllClicked) {
      if (length > 50) {
        setPaginationModel({
          ...paginationModel,
          pageSize: 100
        });
      }
      else if (length > 25) {
        setPaginationModel({
          ...paginationModel,
          pageSize: 50
        });
      }
      else {
        setPaginationModel({
          ...paginationModel,
          pageSize: 25
        });
      }
    } else { // 1 -100
      if (paginationModel.pageSize === 25) {
        ;
      }
      else if (paginationModel.pageSize === 50) {
        if (length <= 25) {
          setPaginationModel({
            ...paginationModel,
            pageSize: 25
          });
        }
      }
      else if (paginationModel.pageSize === 100) {
        if (length <= 25) {
          setPaginationModel({
            ...paginationModel,
            pageSize: 25
          });
        } else if (length <= 50) {
          setPaginationModel({
            ...paginationModel,
            pageSize: 50
          });
        }
      }
    }
  }
}